module.exports = __webpack_public_path__ + "img/电梯动画1.a17fcdb2.png";